import { useNuxtApp, useUserInfo } from '#imports'

export function useNavigationFilter() {
    const { isLoggedIn, isExisting } = useUserInfo()
    const { $i18n } = useNuxtApp()

    function isVisible(item: { hideWhenLoggedIn?: boolean, hideWhenNotLoggedIn?: boolean, hideWhenExisting?: boolean }) {
        if (item.hideWhenLoggedIn && isLoggedIn.value) return false
        if (item.hideWhenNotLoggedIn && !isLoggedIn.value) return false
        if (item.hideWhenExisting && isExisting.value) return false
        return true
    }

    function resolveHref(item: { href?: string, newUserHref?: string, page?: string, newUserPage?: string }) {
        const page = !isExisting.value && item.newUserPage ? item.newUserPage : item.page

        if (page) return $i18n.t(`pages.${page}`)

        return !isExisting.value && item.newUserHref ? item.newUserHref : item.href
    }

    function resolveTitle(item: { title?: string, key?: string }) {
        if (item.title) return item.title

        return item.key ? $i18n.t(`core.navigation.${item.key}`) : ''
    }

    return { isVisible, resolveHref, resolveTitle }
}
